import * as types from './types';

const initialState = {
  searchResults: [],
};

const itemsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ITEM: {
      const { data: itemDetails } = action;
      return { ...state, itemDetails };
    }
    case types.SET_ITEMS: {
      const {
        data: { meta, items: results },
      } = action;
      return { ...state, searchResults: { meta, results } };
    }
    case types.SET_ITEM_PACKAGE: {
      const { data: itemPackageDetails } = action;
      return { ...state, itemPackageDetails };
    }
    default:
      return state;
  }
};

const initialSummaryState = {
};


const searchSummaryReducer = (state = initialSummaryState, action) => {
  switch (action.type) {
    case types.SET_SEARCH_SUMMARY: {
      const { data: searchSummary } = action;
      return { ...state, ...searchSummary };
    }
    default:
      return state;
  }
};

export { itemsReducer, searchSummaryReducer };
